import { useFetch } from 'utils/sdk.ts';

export type ExchangeRate = {
  from_currency: string;
  rate: number;
  to_currency: string;
};

export type ExchangedProposalPrice = {
  currency: string;
  value: number;
};

export type ExchangeRateDto = {
  exchange_rate: ExchangeRate;
  exchanged_proposal_price: ExchangedProposalPrice;
};

export const useFlightTicketProposalExchangeRates = (id?: string) =>
  useFetch<ExchangeRateDto[]>(id ? `api/customer-facing/flight-ticket-proposals/${id}/exchange-rates` : null);
